import { observable } from "mobx";
import { api_adm } from "../../api";
import { INotaVar } from "../../model";
import { toast } from "react-toastify";

class _CalcVarStore {

  obs = observable({
    length: 0 as number,
    vars_calc: [] as INotaVar[],
    loading: false as boolean
  })

  async load(page: number, tipo: string, collection: string) {

    this.obs.loading = true

    try {

      let data = {
        page: page,
        limit: 20,
        tipo: tipo,
        collection: collection
      }

      let resp = await api_adm.post("/api/admin/calc_vars", data)

      this.obs.vars_calc = [];
      this.obs.length = 0;

      if (resp.data.itens.length) {

        this.obs.vars_calc = resp.data.itens
        this.obs.length = resp.data.count

      }

    } catch (ex) {

      toast.error("Erro ao carregar Variáveis!", {});

    }

    this.obs.loading = false

  }

  async put(id: string, descricao: string, collection: string) {

    try {

      let resp = await api_adm.put(`/api/admin/calc_vars/${id}`, { descricao: descricao, collection: collection });

      if (resp.data.ok) {

        return true

      } else {

        toast.success(resp.data.error, {});

      }

    } catch (ex) {

      toast.error("Erro ao carregar Variáveis!", {});

    }

    return false

  }

  async delete(id: string, collection: string) {

    try {

      let resp = await api_adm.post(`/api/admin/calc_vars/delete`, { id: id, collection: collection });

      if (resp.data.ok) {

        return true

      } else {

        toast.success(resp.data.error, {});

      }

    } catch (ex) {

      toast.error("Erro ao deletar Variável!", {});

    }

    return false

  }

}

export const CalcVarStore = new _CalcVarStore();
